import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { redirectToLogIn as redirectToLogInAction } from '../../actions/auth';
import { lookupUser as lookupUserAction } from '../../actions/lookup';
import SignupPage from './SignupPage';

const _mapStateToProps = (state) => ({
    email: state.authentication.email,
    stld: state.authentication.stld,
    fp: state.authentication.fp,
    referrer: state.authentication.referrer,
    socialSSOSettings: state.social.socialSSOSettings,
    captcha: {
        recaptcha2PublicKey: state.authentication.recaptcha2PublicKey,
        recaptcha3PublicKey: state.authentication.recaptcha3PublicKey,
        disableRecaptcha3: state.authentication.disableRecaptcha3,
    },
    gaSettings: state.gaSettings,

    featureFlags: {
        launchGoogleOneTapWeb:
            state.authentication.featureFlags.launchGoogleOneTapWeb,
        launchSignupWithVerificationCode:
            state.authentication.featureFlags.launchSignupWithVerificationCode,
    },
});

const _mapDispatchToProps = {
    redirectToLogInAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SignupPage),
);
